module.exports = __webpack_public_path__ + "assets/img/fastDownload.dde8b0e2.png";